(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ds", [], factory);
	else if(typeof exports === 'object')
		exports["ds"] = factory();
	else
		root["ds"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 